import { useSelector } from 'react-redux'
import _ from '@strings'
import Text from '@components/Ui/Text'
import Spacer from '@components/Ui/Spacer'
import Button from '@components/Ui/Button'
import DataReview from '@components/Modules/DataReview'
import config from '@config'
import styles from './Confirmation.scss'

const Confirmation = () => {
  const mode = useSelector((s) => s.data.mode)

  return (
    <div className={styles.base}>
      <Text type="slab_md" center as="div" e2e="appointments-thank-you-headline">
        {mode === 'live' && _('confirmation.headline_live')}
        {mode !== 'live' && _('confirmation.headline_restricted')}
      </Text>

      <Spacer vertical scale="0.5" />
      <Text type="robo_md" center as="div">
        {mode === 'live' && _('confirmation.headline_second_live')}
        {mode !== 'live' && _('confirmation.headline_second_restricted')}
      </Text>
      <Spacer vertical scale="1" />

      <DataReview showTitle={false} checked showFormData />
      <Spacer vertical scale="1" />
      {mode !== 'live' && (
        <Text center as="div">
          {_('confirmation.text_restricted')}
        </Text>
      )}
      <Text center as="div">
        {_('confirmation.thankyou_text')}
        <br />
        {_('confirmation.thankyou_company')}
      </Text>

      <Spacer vertical scale="1" />
      <div style={{ textAlign: 'center' }}>
        <a href={config.get('local.home')}>
          <Button theme="outline">{_('confirmation.button')}</Button>
        </a>
      </div>
    </div>
  )
}

Confirmation.defaultProps = {}
Confirmation.propTypes = {}

export default Confirmation
